import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import { ChiamaAPI, Trad, BaseComponent, Paginatore } from '../../components/';
import { PortletToogleIcon } from '../common/PortletToogleIcon';
import * as Dashboard from './Dashboard';
import ChiamaWeb, { CChiamaWebParametri } from '../../ChiamaWeb';

export const DashboardAzioniVeloci: React.FC<{}> = () => {
    const [FideiussioniDisponibili, setFideiussioniDisponibili] = useState(false);
    const [canCreateCAR, setCanCreateCAR] = useState(false);
    
    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: "/api/binder/RamiDisponibili?id_AnagA=" + Glob.GetSessione().ID_Anag,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPILista<number>) => {
                for (let I = 0; I < dati.Dati.length; I++) {
                    switch (dati.Dati[I]) {
                        case Glob.TipiRami_Fideiussioni:
                            setFideiussioniDisponibili(true);
                            break;
                    }
                }
            }
        }
        new ChiamaWeb().Chiama(Param);
        let Sessione = Glob.GetSessione();
        if (Sessione.Gruppi.includes("26"))
        {
            setCanCreateCAR(true);
        }
    }, []);

    
    return FideiussioniDisponibili ? (
        <div className="kt-portlet portlet-shadow kt-portlet--sortable" data-ktportlet="true" >
            <div className="kt-portlet__head ui-sortable-handle">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-label">{Trad.Trad("Azioni veloci")}</h3>
                </div>
                <div className="kt-portlet__head-toolbar">
                    <PortletToogleIcon />
                </div>
            </div>
            <div className="kt-portlet__body">
                <div className="kt-widget4">
                    <NavLink to="/fidenuovo" className="text-right kt-padding-r-0 kt-widget4__icon">
                        {Trad.Trad("Nuovi affidamenti/Nuove fideiussioni")}
                    </NavLink>
                </div>
            </div>
            {canCreateCAR && (
                <div className="kt-portlet__body">
                    <div className="kt-widget4">
                        <NavLink to="/createpolicycar" className="text-right kt-padding-r-0 kt-widget4__icon">
                            {Trad.Trad("Nuova polizza CAR")}
                        </NavLink>
                    </div>
                </div>
            )}
        </div>
    ) : null;
}




// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardAzioniVeloci.tsx